import gsap from "gsap";

export function initUiButtonHoverFill() {
  const buttons = document.querySelectorAll(".ui-button");
  if (!buttons.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  buttons.forEach((btn) => {
    const fill = btn.querySelector(".ui-button__fill");
    if (!fill) return;

    // Read hover color from data attribute (fallback to a sensible default)
    const hoverBg = btn.dataset.hover || "#141414";

    // Helper: compute a circle big enough to cover the button
    const setFillAtPointer = (e) => {
      const r = btn.getBoundingClientRect();
      const x = (e.clientX ?? (e.touches && e.touches[0]?.clientX) ?? r.left + r.width / 2) - r.left;
      const y = (e.clientY ?? (e.touches && e.touches[0]?.clientY) ?? r.top + r.height / 2) - r.top;

      // Diameter that guarantees coverage from any point
      const diameter = Math.hypot(r.width, r.height) * 2;

      // Position circle so its center is at (x, y)
      gsap.set(fill, {
        backgroundColor: hoverBg,
        width: diameter,
        height: diameter,
        left: x - diameter / 2,
        top: y - diameter / 2,
      });
    };

    const show = (e) => {
      if (prefersReduced) {
        gsap.set(fill, { opacity: 1, scale: 1 });
        return;
      }

      setFillAtPointer(e);

      gsap.killTweensOf(fill);
      gsap.set(fill, { opacity: 1, scale: 0.001 });

      // SLOW + SMOOTH IN
      gsap.to(fill, {
        scale: 1,
        duration: 0.9,          // slower hover-in
        ease: "power2.out",      // softer ease
      });
    };

    const move = (e) => {
      if (prefersReduced) return;
      if (!gsap.getProperty(fill, "opacity")) return;
      setFillAtPointer(e);
    };

    const hide = () => {
      if (prefersReduced) {
        gsap.set(fill, { opacity: 0, scale: 0 });
        return;
      }

      gsap.killTweensOf(fill);

      // FAST OUT
      gsap.to(fill, {
        scale: 0.001,
        opacity: 0,
        duration: 0.25,          // faster exit
        ease: "expo.out",       // decisive snap-out
      });
    };

    btn.addEventListener("mouseenter", show);
    btn.addEventListener("mousemove", move);
    btn.addEventListener("mouseleave", hide);

    // touch support (optional)
    btn.addEventListener("touchstart", show, { passive: true });
    btn.addEventListener("touchend", hide, { passive: true });
    btn.addEventListener("touchcancel", hide, { passive: true });
  });
}
